.searchIconWrapper {
  width: 16px;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loadingWrapper {
  align-items: center;
  margin-right: 8px;
}

.textField {
  color: inherit;
  background-color: var(--tuna-palette-action-focus);
  border-radius: var(--tuna-shape-borderRadius);
  margin-bottom: 8px;
  padding: 8px;
}
